var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "mb-5" }, [_vm._v("Listado de aprobaciones")]),
      _c("Filters"),
      _c("ApprovalsTable", { attrs: { company: _vm.company } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }